import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request';
import { all, put, takeLatest } from 'redux-saga/effects';
import Api from '../../commons/api';
import { APP_ROUTES } from '../../constants/app-routes';
import * as EventActions from './actions';
import { CREATE_RATING, CREATE_RATING_REPLY, GET_RATINGS_BY_VENUE_OWNER_ID } from './constants';

const controller = 'ratings';

function* getGivenRatingsToUserById({ payload }) {
  try {
    const { userId } = payload;
    const query = RequestQueryBuilder.create()
      .setJoin({ field: 'reviewee' })
      .setJoin({ field: 'reviewer' })
      .setJoin({ field: 'replies' })
      .setFilter({
        field: 'reviewee.id',
        operator: CondOperator.EQUALS,
        value: userId,
      })
      .sortBy({ field: 'created_at', order: 'DESC' })
      .query();
    const { data } = yield Api.get(`${controller}?${query}`);
    yield put(EventActions.getRatingsByVenueOwnerSuccess(data));
  } catch (err) {
    yield put(EventActions.getRatingsByVenueOwnerFailed(err));
  }
}

function* createRating({ payload }) {
  try {
    const { rating } = payload;
    const ratingData = {
      ...rating,
      reviewsUrl: APP_ROUTES.REVIEWS,
    };
    const { data } = yield Api.post(`${controller}`, ratingData);
    yield put(EventActions.createRatingSuccess(data));
  } catch (err) {
    yield put(EventActions.createRatingFailed(err));
  }
}

function* createRatingReply({ payload }) {
  try {
    const { reply } = payload;
    const { data } = yield Api.post(`${controller}/${controller}/reply`, reply);
    yield put(EventActions.createRatingReplySuccess(data));
  } catch (err) {
    yield put(EventActions.createRatingReplyFailed(err));
  }
}

function* ActionWatcher() {
  yield takeLatest(GET_RATINGS_BY_VENUE_OWNER_ID, getGivenRatingsToUserById);
  yield takeLatest(CREATE_RATING, createRating);
  yield takeLatest(CREATE_RATING_REPLY, createRatingReply);
}

export default function* RatingSaga() {
  yield all([ActionWatcher()]);
}
